import { useResourcesUniversal, type ResourcesUniversal, ResourcesValues } from "@/composables/useResourcesUniversal";
import type { ExposeInterface } from './types';
import { Logger } from '@/utils';

export const useHelpStore = defineStore('Help', (): ExposeInterface => {
    const _resources: Ref<ResourcesUniversal | null> = ref(null);
    const getForum: ComputedRef<{[key: string]: string | null}> = computed(() => {
        return {
            link: _resources.value?.resources[ResourcesValues.FORUM_LINK] ??  null,
            url: _resources.value && _resources.value?.resources[ResourcesValues.FORUM_LINK] ? `https://${_resources.value?.resources[ResourcesValues.FORUM_LINK]}` : null
        };
    });
    const getFaq: ComputedRef<{[key: string]: string | null}> = computed(() => {
        return {
            link: _resources.value?.resources[ResourcesValues.FAQ_LINK] ?? null,
            url: _resources.value && _resources.value?.resources[ResourcesValues.FAQ_LINK] ? `https://${_resources.value?.resources[ResourcesValues.FAQ_LINK]}` : null
        };
    });

    const fetchResources = async (): Promise<void> => {
        _resources.value = await useResourcesUniversal('string_resources_universal');

        void checkProps(_resources.value);
    };

    const checkProps = async (props: ResourcesUniversal | null): Promise<void> => {
        try {
            for (const prop in props?.resources) {
                if (!Object.values(ResourcesValues).includes(prop as ResourcesValues)) {
                    throw new Error(`${prop} is not a valid resource`);
                }
                
                if(!props.resources[prop as ResourcesValues]) {
                    throw new Error(`${prop} is empty`);
                }
            }
        } catch (error) {
            Logger.captureError(error as Error);
        }
    };

    const clearHelp = (): void => {
        _resources.value = null;
    };

    return {
        fetchResources,
        getFaq,
        getForum,
        clearHelp
    }
});